<ng-container [ngSwitch]="type" *ngIf="history">
  <ng-container *ngIf="history.date">Gebucht: {{ history.date }},</ng-container>
  <ng-container *ngIf="history.quantities">
    <div *ngFor="let obj of history.quantities">
      Menge: {{ obj|money }},
    </div>
  </ng-container>
</ng-container>
